import { defineComponent, ref, computed } from 'vue'
import useBreakpoints from '@/composables/use-breakpoints'
import { whenever, useMounted, useCurrentElement, useEventListener, onClickOutside } from '@vueuse/core'
import { vOnClickOutside } from '@vueuse/components'
import vOnFocusOutside from '@/directives/on-focus-outside'
// @ts-ignore untyped library
import SlideToggle from 'vue-slide-up-down'
import { Menu, MenuButton, MenuItems, MenuItem, TransitionRoot, Popover, PopoverPanel, PopoverButton } from '@headlessui/vue'


export default defineComponent({
    setup() {
        const breakpoints = useBreakpoints()
        const isLg = breakpoints.greaterOrEqual('lg')
        const el = /** @type {import('@vueuse/core').ComputedRefWithControl<HTMLElement>} */(useCurrentElement())
        const header = computed(() => el.value?.parentElement)
        const isMounted = useMounted()
        const open = ref(false)
        const searching = ref(false)

        // Auto close when isLg
        whenever(isLg, () => {
            open.value = false
            searching.value = false
        })

        // Close hamburger menu on outside events
        onClickOutside(computed(() => open.value ? header.value : null), () => open.value = false)
        useEventListener(computed(() => open.value ? window : null), 'scroll', () => open.value = false)
        useEventListener(computed(() => open.value || searching.value ? document : null), 'keydown', /** @param {KeyboardEvent} event */(event) => {
            if (event.key === 'Escape') open.value = searching.value = false
        })
        useEventListener(computed(() => open.value ? document : null), 'focusin', (event) => {
            if (event.target && !header.value?.contains(/** @type {Node} */(event.target)))
                open.value = false
        })

        return {
            isLg,
            isMounted,
            searching,
            open
        }
    },
    components: {
        SlideToggle,
        Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        TransitionRoot,
        Popover, PopoverPanel, PopoverButton
    },
    directives: {
        onFocusOutside: vOnFocusOutside,
        onClickOutside: vOnClickOutside
    }
})